import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static targets = ["list", "item", "filter", "emptyNote"]

  connect() {
    this.keydown = this.handleKeydown.bind(this)
    this.element.addEventListener("keydown", this.keydown)
  }

  disconnect() {
    this.element.removeEventListener("keydown", this.keydown)
  }

  handleKeydown(event) {
    if (event.target === this.filterTarget) return
    if (!["ArrowUp", "ArrowDown"].includes(event.key)) return
    const items = this.visibleItems()
    const index = items.indexOf(document.activeElement)
    if (index === -1) return
    event.preventDefault()
    const offset = event.key === "ArrowDown" ? 1 : -1
    const next = items[(index + offset + items.length) % items.length]
    next.focus()
  }

  visibleItems() {
    return this.itemTargets.filter((item) => !item.parentElement.classList.contains("hidden"))
  }

  filterChanged() {
    const query = this.filterTarget.value.trim().toLowerCase()
    let anyVisible = false

    this.itemTargets.forEach((item) => {
      const title = item.dataset.title
      const match = query ? matchTitle(query, title) : null
      const visible = !query || match !== null
      item.parentElement.classList.toggle("hidden", !visible)
      if (visible) anyVisible = true
      this.paintLabel(item, title, match)
    })

    this.emptyNoteTarget.classList.toggle("hidden", anyVisible || !query)
  }

  paintLabel(item, title, match) {
    item.replaceChildren()
    if (!match || !match.ranges.length) {
      item.textContent = title
      return
    }
    const markClass = match.direct ? "binder-mark-direct" : "binder-mark-fuzzy"
    let cursor = 0
    match.ranges.forEach(([start, end]) => {
      if (start > cursor) item.appendChild(document.createTextNode(title.slice(cursor, start)))
      const mark = document.createElement("mark")
      mark.className = markClass
      mark.textContent = title.slice(start, end)
      item.appendChild(mark)
      cursor = end
    })
    if (cursor < title.length) item.appendChild(document.createTextNode(title.slice(cursor)))
  }

  filterKeydown(event) {
    if (event.key === "Enter") {
      event.preventDefault()
      const first = this.visibleItems()[0]
      if (first) Turbo.visit(first.href)
    } else if (event.key === "Escape" && this.filterTarget.value) {
      event.preventDefault()
      this.filterTarget.value = ""
      this.filterChanged()
    } else if (event.key === "ArrowDown") {
      event.preventDefault()
      this.visibleItems()[0]?.focus()
    }
  }
}

function matchTitle(query, title) {
  const lower = title.toLowerCase()
  const direct = lower.indexOf(query)
  if (direct >= 0) return { direct: true, ranges: [[direct, direct + query.length]] }

  const ranges = []
  let qi = 0
  let runStart = -1
  let lastMatched = -1
  for (let ti = 0; ti < lower.length && qi < query.length; ti++) {
    if (lower[ti] === query[qi]) {
      if (runStart === -1) runStart = ti
      lastMatched = ti
      qi++
    } else if (runStart !== -1) {
      ranges.push([runStart, lastMatched + 1])
      runStart = -1
    }
  }
  if (runStart !== -1) ranges.push([runStart, lastMatched + 1])
  return qi === query.length ? { direct: false, ranges } : null
}
